(function () {
  if (window.__mbtClassic) return;
  window.__mbtClassic = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  var io = ('IntersectionObserver' in window && !reduce && !design) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('active'); io.unobserve(e.target); } });
  }, { threshold: 0.1 }) : null;

  function scan(root) {
    (root || document).querySelectorAll('.mbt-custom-page .reveal:not(.active)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('active');
    });
  }

  function tick(root) {
    (root || document).querySelectorAll('[data-mbt-ticker]').forEach(function (box) {
      if (box.__mbtTimer) return;
      var items;
      try { items = JSON.parse(box.getAttribute('data-mbt-ticker')); } catch (err) { return; }
      if (!items || items.length < 2 || reduce) return;
      var txt = box.querySelector('[data-t]');
      var ico = box.querySelector('[data-i]');
      var i = 0;
      box.__mbtTimer = setInterval(function () {
        box.style.opacity = '0';
        box.style.transform = 'translateY(-10px)';
        setTimeout(function () {
          i = (i + 1) % items.length;
          txt.textContent = items[i].t;
          ico.textContent = items[i].i;
          box.style.opacity = '1';
          box.style.transform = 'translateY(0)';
        }, 500);
      }, 4000);
    });
  }

  function init() { scan(); tick(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); tick(e.target); });
})();
